import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-ecb332cc")
const _hoisted_1 = { class: "show-video-container" }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.imgList, (item, index) => {
      return (_openBlock(), _createBlock(_component_van_image, {
        onClick: ($event: any) => (_ctx.onClickImg(index)),
        key: item.id,
        radius: "10",
        class: "img",
        src: item.url+'?imageView2/1/w/200/h/200/rotate/0'
      }, null, 8, ["onClick", "src"]))
    }), 128))
  ]))
}